import { Switch, Route, Redirect } from "react-router-dom";

// Pages
import MTPPublicInvestmentPlan from "pages/MTPPublicInvestmentPlan";
import InvestmentStreams from "pages/InvestmentStreams";
import StateSectoralPipelines from "pages/StateSectoralPipelines";
import StateSingleProjectPipeline from "pages/StateSingleProjectPipeline";
import ExpertEvaluationOfProjectsAndPrograms from "pages/ExpertEvaluationOfProjectsAndPrograms";
import PublicInvestmentProjectDetails from "pages/PublicInvestmentProjectDetails";

// helper: build archive URL and jump there
const toArchive = (slug) => ({ location }) => {
  const host = (process.env.REACT_APP_QLIK_SERVER || "").trim();       // e.g. bi.qnalytics.com or bi.dream.gov.ua
  let base  = ("/" + (process.env.PUBLIC_URL || "/archive/")).replace(/\/+/g, "/"); // e.g. /dream/archive/ or /archive/
  if (!base.endsWith("/")) base += "/";

  const origin = window.location.protocol + "//" + host;
  const url = origin + base + (location.search || "") + "#/" + slug;

  window.location.replace(url);
  return null; // render nothing
};

export default function Routes({ menuLayout }) {

  return (
    <Switch>

      <Route exact path="/projects"                render={toArchive("projects")} />
      <Route exact path="/projectDetails"          render={toArchive("projectDetails")} />
      <Route exact path="/financing"               render={toArchive("financing")} />
      <Route exact path="/financingDetails"        render={toArchive("financingDetails")} />
      <Route exact path="/budget"                  render={toArchive("budget")} />
      <Route exact path="/contractingProcesses"    render={toArchive("contractingProcesses")} />
      <Route exact path="/investmentProjects"      render={toArchive("investmentProjects")} />
      <Route exact path="/investmentProjectsLocations" render={toArchive("investmentProjectsLocations")} />
      <Route exact path="/dataAvailability"        render={toArchive("dataAvailability")} />
      <Route exact path="/finPrograms"             render={toArchive("finPrograms")} />
      <Route exact path="/finProgramsDetails"      render={toArchive("finProgramsDetails")} />
      <Route exact path="/applications"            render={toArchive("applications")} />

      <Route exact path="/mtp">
        <MTPPublicInvestmentPlan title={menuLayout.MenuItem15} isAppReady={menuLayout.isAppReady} appDisclaimer={menuLayout.appDisclaimer} pageTitle={menuLayout.HeaderTitle} ExportChartFootnote={menuLayout.ExportChartFootnote} menuItemsStrings={menuLayout}/>
      </Route>
      <Route path="/investmentStreams">
        <InvestmentStreams title={menuLayout.MenuItem16} appDisclaimer={menuLayout.appDisclaimer} pageTitle={menuLayout.HeaderTitle} ExportChartFootnote={menuLayout.ExportChartFootnote} menuItemsStrings={menuLayout} />
      </Route>
      <Route path="/sp">
        <StateSectoralPipelines title={menuLayout.MenuItem17} appDisclaimer={menuLayout.appDisclaimer} pageTitle={menuLayout.HeaderTitle} ExportChartFootnote={menuLayout.ExportChartFootnote} menuItemsStrings={menuLayout} />
      </Route>
      <Route path="/spp">
        <StateSingleProjectPipeline title={menuLayout.MenuItem18} appDisclaimer={menuLayout.appDisclaimer} pageTitle={menuLayout.HeaderTitle} ExportChartFootnote={menuLayout.ExportChartFootnote} menuItemsStrings={menuLayout} />
      </Route>
      <Route path="/expertEvaluation">
        <ExpertEvaluationOfProjectsAndPrograms title={menuLayout.MenuItem19} appDisclaimer={menuLayout.appDisclaimer} pageTitle={menuLayout.HeaderTitle} ExportChartFootnote={menuLayout.ExportChartFootnote} menuItemsStrings={menuLayout} />
      </Route>
      <Route path="/pipDetails">
        <PublicInvestmentProjectDetails title={menuLayout.MenuItem20} appDisclaimer={menuLayout.appDisclaimer} pageTitle={menuLayout.HeaderTitle} ExportChartFootnote={menuLayout.ExportChartFootnote} menuItemsStrings={menuLayout} />
      </Route>
      <Redirect to="/spp" />      
    </Switch>
  );
}
